"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc998Composition = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_intl_1 = require("react-intl");
const react_1 = require("react");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const unWhitelistChild_json_1 = __importDefault(require("@framework/abis/json/ERC998Simple/unWhitelistChild.json"));
const whiteListChild_json_1 = __importDefault(require("@framework/abis/json/ERC998Simple/whiteListChild.json"));
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const provider_user_1 = require("@dzambalaorg/provider-user");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const types_2 = require("../../../../types");
const form_1 = require("./form");
const search_1 = require("./search");
const dialogs_1 = require("../../../../dialogs");
const validation_1 = require("./form/validation");
const ERC998_COMPOSITION_URL = "/erc998/composition";
const Erc998Composition = (props) => {
    const { service } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const initialSearchValues = (0, react_1.useMemo)(() => {
        return {
            parentIds: [],
            childIds: [],
            merchantId: (service === types_2.ServiceType.OFFICE && profile.merchantId) || undefined,
        };
    }, [service, profile]);
    const isMd = (0, material_1.useMediaQuery)(theme => theme.breakpoints.down("md"));
    const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount, refetch } = (0, react_hooks_1.useFetchQuery)(ERC998_COMPOSITION_URL, { enableInfiniteScroll: isMd }, void 0, initialSearchValues);
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { openViewDialog } = (0, dialogs_1.useGlobalDialogViewCallbacks)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { execute: metaFn1 } = (0, react_hooks_eth_1.useMetamask)(async (composition) => {
        return writeContractAsync({
            address: composition.parent.address,
            abi: unWhitelistChild_json_1.default,
            functionName: "unWhitelistChild",
            args: [composition.child.address],
        });
    });
    const handleDeactivate = (composition) => {
        return () => {
            return metaFn1(composition);
        };
    };
    const { execute: metaFn2 } = (0, react_hooks_eth_1.useMetamask)(async (composition) => {
        return writeContractAsync({
            address: composition.contract.parent.contract,
            abi: whiteListChild_json_1.default,
            functionName: "whiteListChild",
            args: [composition.contract.child.contract, composition.amount],
        });
    });
    const handleCreateConfirm = async ({ data }) => {
        await metaFn2(data);
    };
    const handleActivate = (composition) => {
        const values = {
            contract: {
                parent: {
                    contract: composition.parent.address,
                },
                child: {
                    contract: composition.child.address,
                },
            },
            amount: `${composition.amount}`,
        };
        return () => {
            return handleCreateConfirm({ data: values });
        };
    };
    const onErc998CompositionCreate = () => {
        openDialog(dialogs_1.GlobalDialogKeys.ERC998_COMPOSITION_CREATE, { amount: 0 }, {
            refetch,
            initialValues: form_1.initialValues,
            validationSchema: validation_1.erc998CompositionFormValidationSchema,
            message: "dialogs.create",
            testId: "Erc998CompositionCreateForm",
            onExternalConfirm: handleCreateConfirm,
        });
    };
    const onViewComposition = (composition) => () => {
        openViewDialog(dialogs_1.GlobalDialogKeys.ERC998_COMPOSITION_VIEW, composition, {
            message: "dialogs.view",
        });
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "erc998", "erc998.composition"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.erc998.composition.title", children: (0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "secondary", startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.Add, {}), onClick: onErc998CompositionCreate, "data-testid": "Erc998CompositionCreateButton", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.create" }) }) }), (0, jsx_runtime_1.jsx)(search_1.ERC998CompositionsSearch, { initialSearchValues: initialSearchValues, service: service }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledListWrapper, { count: allRows.length, isLoading: isLoading, children: allRows.map(composition => ((0, jsx_runtime_1.jsxs)(styled_1.StyledListItem, { children: [(0, jsx_runtime_1.jsxs)(ui_kit_1.List.ItemText, { children: [composition.parent?.title, " + ", composition.child?.title] }), (0, jsx_runtime_1.jsxs)(styled_1.ListActions, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: onViewComposition(composition), message: "form.tips.view", icon: icons_material_1.Visibility }), composition.compositionStatus === types_1.CompositionStatus.ACTIVE ? ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleDeactivate(composition), message: "form.buttons.deactivate", icon: icons_material_1.PauseCircleOutline })) : ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleActivate(composition), message: "form.buttons.activate", icon: icons_material_1.PlayCircleOutline }))] })] }, composition.id))) }) }), !isMd && totalCount > take && ((0, jsx_runtime_1.jsx)(styled_1.StyledPagination, { shape: "rounded", page: skip / take + 1, count: Math.ceil(totalCount / take), onChange: onChangePage })), isMd && hasNextPage && (0, jsx_runtime_1.jsx)("div", { ref: loadMoreRef, style: { height: "20px", margin: "20px 0" } })] }));
};
exports.Erc998Composition = Erc998Composition;
//# sourceMappingURL=index.js.map